export const SOCIALS = {
  instagram: "https://instagram.com/hunarsyal",
  instagramDM: "https://ig.me/m/hunarsyal",
  youtube: "https://youtube.com/@hunarsyal",
  linkedin: "https://www.linkedin.com/in/hunarsyal",
  // Placeholder, swap the phone number in when Hunar shares it.
  // Format: https://wa.me/<country-code+number>
  whatsapp: "https://wa.me/919999999999",
  whatsappHandle: "@hunarsyal",
};

export const PHOTOS = {
  bhutan: "/images/bhutan.webp",
  livingRoom: "/images/living-room.webp",
  selfie: "/images/selfie.webp",
  golf: "/images/golf.webp",
  christmas: "/images/christmas.webp",
};

export const IMAGES = {
  showVideoThumb: "/images/show-video.webp",
  showVideoId: "cIjvRwuDriE",
  showVideoStart: 106,
};

/*
 * Instagram reels. Swap `url` for the actual reel link and `cover`
 * for a screenshot of that reel once Hunar shares them. The section
 * is horizontally scrollable, like Shopify UGC widgets.
 */
export const REELS = [
  {
    id: 1,
    url: "https://www.instagram.com/hunarsyal/reel/DYCa1W6TV3M/",
    cover: "https://images.unsplash.com/photo-1493612276216-ee3925520721?auto=format&fit=crop&w=800&q=80",
    caption: "Latest from @hunarsyal",
  },
  {
    id: 2,
    url: "https://www.instagram.com/hunarsyal/reel/DYFOJQbzj58/",
    cover: "https://images.unsplash.com/photo-1522252234503-e356532cafd5?auto=format&fit=crop&w=800&q=80",
    caption: "Latest from @hunarsyal",
  },
  {
    id: 3,
    url: "https://www.instagram.com/hunarsyal/reel/DYxFwjkTEBQ/",
    cover: "https://images.unsplash.com/photo-1587174486073-ae5e5cff23aa?auto=format&fit=crop&w=800&q=80",
    caption: "Latest from @hunarsyal",
  },
  {
    id: 4,
    url: "https://www.instagram.com/hunarsyal/reel/DZxUe7zzvJi/",
    cover: "https://images.unsplash.com/photo-1523240795612-9a054b0db644?auto=format&fit=crop&w=800&q=80",
    caption: "Latest from @hunarsyal",
  },
];

export const BRANDS = [
  {
    name: "Hi Tours",
    url: "https://www.hitours.group",
    desc: "Personalised leisure travel, luxury escapes and curated adventures.",
  },
  {
    name: "Hi Offsite",
    url: "https://www.hitours.group/brands",
    desc: "Corporate offsites, incentives and business travel for culture-first teams.",
  },
  {
    name: "Hi DMC",
    url: "https://hidmc.in",
    desc: "Destination management trusted by global tour operators across 15+ destinations.",
  },
];

/*
 * Tags let readers discover essays across categories. Each essay carries
 * 2-3 tags. Clicking a tag opens /tags/:slug filtered to that theme.
 */
export const TAGS = [
  { slug: "mindset", label: "Mindset" },
  { slug: "entrepreneurship", label: "Entrepreneurship" },
  { slug: "life", label: "Life" },
  { slug: "relationships", label: "Relationships" },
  { slug: "growth", label: "Growth" },
  { slug: "evolution", label: "Evolution" },
  { slug: "discipline", label: "Discipline" },
  { slug: "money", label: "Money" },
  { slug: "career", label: "Career" },
];

export const INTERESTS = [
  { label: "Travel", icon: "plane" },
  { label: "Entrepreneurship", icon: "briefcase" },
  { label: "Tech & how it changes work", icon: "cpu" },
  { label: "Golf", icon: "flag" },
  { label: "The gym", icon: "dumbbell" },
];

/*
 * Essay bodies are block-based so the article page can render real
 * structure, headings, sub-headings, pull quotes, lists and callouts ,
 * instead of one long wall of text.
 */
export const ESSAYS = [
  {
    id: 1,
    slug: "the-art-of-doing-less-better",
    category: "Mindset",
    tags: ["mindset", "growth", "discipline"],
    title: "The Art of Doing Less, Better",
    subtitle: "Why the highest performers in every field look almost lazy from the outside.",
    readTime: "6 min read",
    date: "January 2026",
    body: [
      { type: "p", text: "There is a strange rule I have noticed about the people who are actually winning. From the outside, most of them look almost lazy. They are not on every podcast, not on every panel, not replying to every email. They are quietly obsessed with two or three things, and they refuse to be dragged into a fourth." },
      { type: "p", text: "For years I thought the answer to a bigger life was doing more. More meetings, more calls, more launches, more books, more workouts. The math seemed simple. Effort in, output out. But there is a version of hard work that is really just anxiety with a to-do list attached, and I lived in that version for a long time." },
      { type: "h2", text: "The shift" },
      { type: "p", text: "The shift for me started when I realised that the things I was proud of, actually proud of, all came from long stretches of doing very little else. The best business decisions I have made were made after weeks of thinking, not after a productive Tuesday. The best writing I have done came after saying no to seven other things I could have written instead." },
      { type: "blockquote", text: "Doing less, better is not about laziness. It is about resolution." },
      { type: "p", text: "It is about being willing to look at your calendar and admit that most of what is on it is negotiable, and a lot of it is other people's priorities dressed up as yours. It is uncomfortable, because saying no to something small usually means disappointing someone in a small way. Nobody teaches you how to do that gracefully. You just have to practice it until the discomfort becomes bearable." },
      { type: "h2", text: "What the winners actually do" },
      { type: "p", text: "The people I admire most, when I ask them what they said no to, the list is long and specific. They can tell you exactly what they turned down last month and why. The people I do not admire tend to give a vague answer, because they never actually decided. They just accepted whatever came in." },
      { type: "list", items: [
        "They pick two or three things and go deep.",
        "They protect their calendar like it is a scarce resource.",
        "They can explain, in one sentence, what they are optimising for this year.",
        "They are not afraid to say a boring no to an exciting opportunity.",
      ]},
      { type: "h2", text: "A small experiment" },
      { type: "p", text: "Look at everything you are working on right now and ask which two of them, if they went absurdly well, would change the shape of your year. Then look at everything else. That is your no list. Protect it like your life depends on it. Because, in a way, it does." },
    ],
  },
  {
    id: 2,
    slug: "nobody-is-coming-to-save-your-career",
    category: "Career",
    tags: ["career", "entrepreneurship", "mindset"],
    title: "Nobody Is Coming to Save Your Career",
    subtitle: "And why that is the best news you will hear all year.",
    readTime: "7 min read",
    date: "January 2026",
    body: [
      { type: "p", text: "There is a specific kind of quiet panic that sets in around your late twenties, and it usually happens on a Sunday evening. You have a decent job. You are not broke. On paper, things look fine. But there is a small voice at the back of your head asking why nothing feels like it is actually moving." },
      { type: "p", text: "Most of us, when we hear that voice, look outward. We wait for a manager to notice us. We wait for the promotion cycle. We wait for someone senior to take us under their wing, for a company to reorganise in our favour, for the economy to turn, for our industry to reward what we are already doing. We treat our career like something that will happen to us if we are patient and polite." },
      { type: "blockquote", text: "It will not." },
      { type: "p", text: "This is not cynicism. It is one of the most freeing things you will ever accept. Because if nobody is coming, then the only person who can move you is you. And that person, unlike everyone else, is actually in the room right now." },
      { type: "h2", text: "What compounders do differently" },
      { type: "p", text: "The people who compound in their careers do a few things very differently. They stop waiting for permission to do the work that matters. They pick a lane and go deep, even when the lane looks small. They ask for the meeting, the raise, the introduction, the feedback. They are willing to look a little foolish for a long time in exchange for looking impressive later." },
      { type: "p", text: "They understand that a career is not a ladder that someone else is holding at the top. It is more like a rock face, and you climb it one weird decision at a time." },
      { type: "h2", text: "The Sunday question" },
      { type: "p", text: "So the question I would sit with, if that Sunday feeling is familiar to you, is not what is wrong with my company or my industry or my manager. It is what would I do this quarter if I fully believed that nobody was coming. What would I ask for. What would I ship. What would I stop doing." },
      { type: "p", text: "That is where your career actually starts." },
    ],
  },
  {
    id: 3,
    slug: "why-your-circle-decides-your-ceiling",
    category: "Relationships",
    tags: ["relationships", "growth", "life"],
    title: "Why Your Circle Decides Your Ceiling",
    subtitle: "The five people you spend the most time with are silently voting on your future.",
    readTime: "5 min read",
    date: "December 2025",
    body: [
      { type: "p", text: "You can measure a lot about someone's next five years just by sitting in on their WhatsApp groups for a week. Not because their friends are good or bad, but because the ambient conversation in your life is quietly setting the ceiling for what feels normal to you." },
      { type: "p", text: "If everyone around you is complaining about their boss, you will start complaining about yours. If everyone around you is building something, you will feel restless until you are too. This is not about willpower. It is about environment. Humans are calibration machines. We adjust our sense of what is possible to match the room we are in." },
      { type: "h2", text: "You did not choose your circle. You inherited it." },
      { type: "p", text: "The uncomfortable part is that you do not really choose your circle by accident. You choose it by convenience. The friends you kept because they lived near you. The colleagues you drink with because they sit next to you. Over time, this becomes your operating system, and you barely notice it." },
      { type: "blockquote", text: "The best career advice I ever got was not about a job. It was about upgrading my rooms." },
      { type: "p", text: "Start sitting in conversations where the average person is doing something a little bigger than you are. Not to network. Not to extract. Just to recalibrate what normal looks like. Do this for a year and your definition of what is possible quietly shifts." },
      { type: "p", text: "None of this means abandoning old friends. It means being honest about who you become around each person, and being intentional about the balance. Your circle is not fate. It is a decision you make, quietly, every week, with your calendar." },
    ],
  },
  {
    id: 4,
    slug: "discipline-is-a-love-language",
    category: "Growth",
    tags: ["discipline", "growth", "mindset"],
    title: "Discipline Is a Love Language You Speak to Yourself",
    subtitle: "The version of you five years from now is being built or broken today.",
    readTime: "5 min read",
    date: "December 2025",
    body: [
      { type: "p", text: "We usually talk about discipline like it is punishment. Something you do to yourself. Something cold. Something reserved for people who wake up at four in the morning and film themselves doing it." },
      { type: "p", text: "But if you turn it around, discipline is actually one of the kindest things you can do for the version of you that has not shown up yet. Every time you do the thing you said you would do, you are quietly telling the future you, I have got you. When you skip it, you are telling that same person, you are on your own." },
      { type: "h2", text: "Motivation is a negotiation. Discipline is a decision." },
      { type: "p", text: "The reason motivation fails is that it treats every workout, every writing session, every difficult conversation like a fresh negotiation. Discipline removes the negotiation. It says, we do not have to feel like it, we just have to do it. That is love. It is not shiny love. It is the boring, reliable, adult kind." },
      { type: "blockquote", text: "The streak is not the point. The relationship with yourself is the point." },
      { type: "p", text: "The most disciplined people I know are also, without exception, the most self-forgiving. They miss a day and they do not spiral. They skip a workout and they do not throw out the month. They just start again." },
      { type: "p", text: "So think about your future self as an actual person you love. What are you doing today that they will thank you for. That is the only measure of discipline that matters." },
    ],
  },
  {
    id: 5,
    slug: "the-first-crore-is-a-mindset-problem",
    category: "Money",
    tags: ["money", "entrepreneurship", "mindset"],
    title: "The First Crore Is a Mindset Problem, Not a Math Problem",
    subtitle: "How I stopped budgeting my way to nowhere and started thinking about money like a builder.",
    readTime: "8 min read",
    date: "November 2025",
    body: [
      { type: "p", text: "For years I tried to save my way to my first crore. I tracked my spending on three different apps. I read every personal finance book I could find. I optimised my SIPs like they were a hobby. And at the end of it, I was still moving forward at the pace of a very disciplined snail." },
      { type: "p", text: "Then something changed, and it was not on the math side. It was in how I thought about money itself. I stopped treating it like a bucket I had to fill with drops. I started treating it like a system I had to design." },
      { type: "h2", text: "Shift one: saving alone will not get you there" },
      { type: "p", text: "The math is brutal. If you save an aggressive slice of a good salary for twenty years and invest it well, you will get somewhere. But if you want to build real wealth in a reasonable amount of time, you will need something that scales beyond your paycheck. That could be equity, a business, a side income, a skill people will pay a premium for. Something with a ceiling higher than your salary." },
      { type: "h2", text: "Shift two: fix the story before the spreadsheet" },
      { type: "p", text: "Most people are not held back by their income. They are held back by their story about money. If you grew up hearing money is dirty, or money is scarce, or rich people are shady, that story runs quietly in the background of every financial decision you make. You will unconsciously sabotage the outcomes you say you want." },
      { type: "blockquote", text: "Fixing your relationship with money is not a mindset hack. It is the actual work." },
      { type: "h2", text: "Shift three: wealth is not linear" },
      { type: "p", text: "The first crore feels impossibly far when you are staring at your savings account. But it does not compound linearly. It compounds in ugly, unfair, non-linear jumps. One good decision, one right partnership, one right skill, and the graph bends. You will not see it while it is happening. You will only see it in hindsight." },
      { type: "p", text: "The math matters. Of course it matters. But the math will follow the mindset. Fix the story first." },
    ],
  },
  {
    id: 7,
    slug: "what-golf-taught-me-about-business",
    category: "Growth",
    tags: ["growth", "entrepreneurship", "life"],
    title: "What Golf Taught Me About Business",
    subtitle: "The four-hour walk that quietly rewired how I think about work, patience and long games.",
    readTime: "6 min read",
    date: "February 2026",
    body: [
      { type: "p", text: "I picked up golf later than most of the people I play with. I thought it would be a nice weekend hobby, a way to switch off, maybe close a few deals along the way. What I did not expect was how quickly it would become the clearest mirror I have on how I run my businesses." },
      { type: "p", text: "Golf is the only sport I know where you are, essentially, alone. The ball is not moving until you hit it. Nobody is defending you. Nobody is stealing time from your clock. There is just you, the club, the ball, and about six hours of your own thoughts. And that turns out to be brutally revealing." },
      { type: "image", src: "https://images.unsplash.com/photo-1587174486073-ae5e5cff23aa?auto=format&fit=crop&w=1600&q=80", alt: "Early morning tee box on a quiet golf course", caption: "An early morning at the course. The best business thinking I do all week happens somewhere between holes six and eleven." },
      { type: "h2", text: "Lesson one: the swing is a metaphor for everything" },
      { type: "p", text: "The single biggest mistake beginners make in golf is trying to hit the ball hard. You watch pros and their swings look effortless, almost lazy. That is because the power does not come from the hit. It comes from the setup, the rotation, the tempo, the follow-through. The ball is almost a byproduct." },
      { type: "p", text: "Business is exactly the same. The people I watch trying to force outcomes are the ones with the worst results. The ones building something real are almost boring to watch. Slow. Deliberate. Repeatable. They are not hitting the ball harder. They are hitting it better." },
      { type: "blockquote", text: "The best swings and the best companies look easy from the outside because someone earned the right to make them look easy." },
      { type: "h2", text: "Lesson two: your last shot doesn't matter" },
      { type: "p", text: "You could hit a perfect drive on hole four and immediately duff your next shot. Both go into the same score. The only shot that matters is the next one. Golfers who cannot let go of the last bad shot compound their mistakes. Golfers who cannot let go of the last good shot get complacent." },
      { type: "p", text: "In business, we spend way too much time replaying the previous quarter and not nearly enough time playing the next one. The scoreboard resets on Monday whether you like it or not." },
      { type: "video", provider: "youtube", id: "GXTb1sQZLIQ", title: "The best golf mental game advice I have heard" },
      { type: "h2", text: "Lesson three: it is a four-hour walk, not a game" },
      { type: "p", text: "The actual time you spend hitting the ball on a round of golf is about ten minutes. The rest is walking, standing, waiting, talking. That is the real product." },
      { type: "p", text: "I have closed more partnerships walking between shots than I ever have in a conference room. Not because I was trying to. Because you cannot fake four hours of continuous, low-stakes company with someone. Either the trust is there or it is not, and by the sixteenth hole, you know." },
      { type: "h2", text: "Lesson four: your worst shot is somebody else's best" },
      { type: "p", text: "When I started, I was embarrassed to play with better golfers. Then I realised the fastest way to get better was to play with people I had no business playing with. Their standard becomes yours. You start to see the game differently. What used to look impossible starts looking like something you might, one day, do." },
      { type: "p", text: "This is exactly why I try to spend as much time as I can around entrepreneurs a few steps ahead of me. Not to network. Not to extract. Just to be in the room. Watching how they think, how they say no, how they lose. That is the real education." },
      { type: "p", text: "Golf will probably keep teaching me things for the rest of my life. That is the whole point. Some games are worth playing precisely because you can never finish them." },
    ],
  },
  {
    id: 6,
    slug: "stop-waiting-for-clarity",
    category: "Mindset",
    tags: ["mindset", "growth", "evolution"],
    title: "Stop Waiting for Clarity. Start Creating It.",
    subtitle: "Clarity is a byproduct of action, not the ticket you need to buy before starting.",
    readTime: "4 min read",
    date: "November 2025",
    body: [
      { type: "p", text: "The most expensive lie I ever told myself was that once I had clarity, I would move. Once I knew exactly what I wanted, exactly which path to take, exactly which business to build, I would go all in. Until then, I was going to think about it a little longer." },
      { type: "blockquote", text: "I lost years to that sentence." },
      { type: "p", text: "Here is the thing about clarity: it is almost never something you find in your head. You do not sit still and think your way into a clear life. You act your way into one. You start something small, you notice how it feels, you follow the pull. Clarity is a result, not a prerequisite." },
      { type: "h2", text: "The people who look certain are lying" },
      { type: "p", text: "The people who look like they always knew what they wanted are lying, usually to themselves. What they actually did was pick something reasonable, commit hard for a while, and let the doing sharpen the direction. The clarity showed up on the way." },
      { type: "p", text: "So if you are stuck, stop looking for the perfect answer. Pick the least wrong option and go. You can always course correct once you are moving. You cannot course correct while parked." },
    ],
  },
];

export const QUOTES = [
  {
    id: 1,
    slug: "fewer-excuses-dressed-up-as-plans",
    text: "You don't need more time. You need fewer excuses dressed up as plans.",
    meaning:
      "Most of us don't have a time problem. We have an honesty problem. We build elaborate plans, buy the courses, make the lists, and call it progress. But planning is often just procrastination wearing a suit. This quote is a reminder to audit yourself: is this a real plan, or a sophisticated way of avoiding the work? The people I know who actually build things have surprisingly simple plans. They keep the vision short, the next step obvious, and the doing loud. Everyone else has a thirty-tab notion doc and nothing shipped.",
  },
  {
    id: 2,
    slug: "comfort-is-a-debt",
    text: "Comfort is a debt. You always pay it back with interest.",
    meaning:
      "Every time you choose the easy option, skip the gym, avoid the hard conversation, or stay in the safe job, you're borrowing against your future self. The bill always arrives, and it's always bigger than the original amount. Discomfort now is the cheapest price you'll ever pay for the life you want. The interest on comfort is silent. You do not feel it in the moment. You feel it five years later, when the version of you that could have existed is a stranger to the version of you that actually shows up.",
  },
  {
    id: 3,
    slug: "consistent-so-luck-finds-you",
    text: "Be so consistent that luck has no choice but to find you.",
    meaning:
      "Luck isn't random. It's a surface area problem. The person who shows up every single day creates thousands of tiny collision points with opportunity. You can't control when your break comes, but you can absolutely control whether you're standing there when it does. Every lucky break I have had came after a long stretch of nothing happening. The stretch was the actual work. The break just had good timing. If you stay in the game long enough, luck starts to look a lot like inevitability.",
  },
  {
    id: 4,
    slug: "started-before-they-were-ready",
    text: "The person you're jealous of started before they were ready too.",
    meaning:
      "Envy is usually just admiration that hasn't been converted into action yet. Everyone you look up to began as a beginner who felt like a fraud. The gap between you and them isn't talent. It's the number of days they've been willing to be bad at something in public. Nobody feels ready. That is not a bug in the process. That is the process. If you wait for the feeling, you will wait forever. The only way past the fraud feeling is through the doing, one embarrassing draft at a time.",
  },
];

export const SHOW_GUESTS = [
  "Founders & entrepreneurs",
  "Creators & storytellers",
  "Athletes & performers",
  "Doctors & scientists",
  "Thinkers & psychologists",
];
